import { apiFetch } from '@/shared/api/apiFetch';
import { HomeSectionsApi, homeSectionsResponseSchema } from '@/entities/home/model/homeSchema';

export async function fetchHomeSections() {
  const json = await apiFetch<HomeSectionsApi>('/home/sections', { method: 'GET' });
  return homeSectionsResponseSchema.parse(json);
}
